<template>
  <div v-if="hasFields" class="FormSectionFields">
    <Field
      v-for="{ key, label } in sectionTemplateFields"
      :key="key"
      :label="label"
      :maxLength="60"
      :value="sectionFieldsProxy[key]"
      @update:value="setFieldValue(key, $event)" />
  </div>
</template>

<script>
export default {
  props: {
    sectionFields: Object,
    sectionTemplateFields: Array,
  },
  computed: {
    hasFields() {
      return !!this.sectionTemplateFields.length
    },
    sectionFieldsProxy() {
      return Object.fromEntries(this
        .sectionTemplateFields
        .map(({ key }) => [
          key,
          this.sectionFields[key] || '',
        ]))
    },
  },
  methods: {
    setFieldValue(key, value) {
      this.$up(`sectionFields.${key}`, value)
    },
  },
}
</script>

<style lang="scss">
.FormSectionFields {
}
</style>
